/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnimatedButton from '../../../components/Animation/AnimatedButton';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import FilterBtn from './Filter';
import ObserverExport from '../ObserverExport';
import { popFromSubDivArray } from '../../ManagePatient/AddPatient/Components/subdivisionSlice';
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideOrganizationQuery} from '../../../slices/patientSlice'
import { handleSidebarPrvState } from '../../../redux/systemConfigSlice';

const TopBarIndividual = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    userArr,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    searchParams,
    exportCols,
    username,
    checkedArr,
    toAddScreen,
    isExport,
    setConfirmationState,
    data,
    exportObservers,
    isIdexport,
    setSubDivisionDataLoading,
    subDivisionDataLoading,
    setMultiDelete,

}) => {
    const { setToastErrorMessage, isSideBar,setIsAdvancedSearchOpen,setIsSideBar } = useContext(GlobalContext);
    const dispatch = useDispatch()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const [dateError, setdateError] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state.MultiSelectSliceConditionally.selectedRows.selectedIds)
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const ref = useRef()
    const ref2 = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const [deleteLoading, setDeleteLoading] = useState(false)
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    function generateArray(params, object) {
        const result = {};
        if (searchParams?.get('subdivision_ids') === null) {
            dispatch(popFromSubDivArray('clearall'))
        }
        const keysToCheck = ['start_date', 'end_date', 'subdivision_ids', 'status'];
        for (const key of keysToCheck) {
            if (params[key] && key !== 'start_date' && key !== 'end_date') {
                const values = params[key].split(',');
                if (key === 'organization_id') {
                    result[key] = filtervals['organization_id'];
                    result['organization_name'] = filtervals['organization_name'];
                } else {
                    result[key] = values;
                }
            } else if (Object.keys(filtervals).length !== 0 && object?.hasOwnProperty(key) && params[key]) {
                result[key] = filtervals[key];
            }
        }

        return result;
    }

    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};

        searchParams.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
        const params = getSearchParams()
        const resultArray = generateArray(params, filterValues);
        setFilterValues(resultArray)
        //dispatch(handleAddFilterValues(resultArray))
        setIsFilterOpen(!isFilterOpen)
    }

    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }
    
    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-list-observers');
        } else {
            setQueryParamsorg('type=org-user-list-observers');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    // Function to handle onClick logic for searchbar open
    const handleSearchClick = () => {
                
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
                  
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    return (
        <>
            <div className="flex justify-between items-center mb-[14px]">
                <div className='flex ts:justify-between items-center tapbar-observer min-w-fit'>
                    {title !== undefined ?
                        <h1 className="text-xl font-normal text-[#000000] min-w-fit 2xl:pt-0 pt-2 self-start 2xl:self-center">{title}</h1>
                        :
                        pathPlaceholder &&
                        <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                            <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                        </Link>
                    }
                    <span onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-max cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                </div>
                                        
                <div className="flex items-center w-full justify-end relative observer_header">
                    <div className='flex items-center'>
                        {menuBar && <div className='relative 2xl:mb-0 mb-2.5'>
                            <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[11px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen) }}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                            >
                                {
                                    isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                                }
                            </button>
                            {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                                <li>
                                    <ul>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("activate") }}
                                                buttonName={"Activate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? 'text-[#6e6d6d]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                            />
                                        </li>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("deactivate") }}
                                                buttonName={"Deactivate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? 'text-[#706a6a]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                            />
                                        </li>
                                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Delete Observers</li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <AnimatedButton
                                                        handleClick={(e) => {setMultiDelete(true) ,setIsChangeStatusOpen(false)}}
                                                        buttonName={"Delete"}
                                                        datatestid="delete-observer"
                                                        disabled={deleteLoading}
                                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} `} />
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>}
                        </div>}
                        
                        <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                            <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                        </button>
                    </div>
                    <div className='flex items-center'>
                        {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterBtn
                            dateError={dateError}
                            setdateError={setdateError}
                            searchParams={searchParams}
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            subDivisionDataLoading={subDivisionDataLoading}
                            userArr={userArr}
                            checkedArr={checkedArr}
                        />
                        }
                        {(SearchInput || isExport) && data !== undefined && data?.data?.length > 0 && <div className='2xl:mb-0 mb-2.5'>  <ObserverExport
                            selectedRows={selectedRows}
                            exportObservers={exportObservers}
                            exportCols={exportCols}
                            setIsFilterOpen={setIsFilterOpen}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            isIdexport={isIdexport} username={username}
                            TotalCount={data?.total_count} />
                        </div>}
                        {isExport &&
                        <>{<Link to={''}>
                            <button type='button'
                                id="view_export_history"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`}>
                                View Export History
                            </button>
                        </Link>}</>}
                        {AddButton &&
                        <>{<Link to={toAddScreen} state={Object.fromEntries(searchParams)}>
                            <button type='button'
                                id="Add user"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`} style={{ 'width': 'max-content' }}>
                                <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                                <span>{buttonName}</span>
                            </button>
                        </Link>}</>}
                    </div>
                </div>
            </div>
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
        
    );
}

export default TopBarIndividual;
